import React, { createContext, useContext, useEffect, useState } from 'react';

export interface Topic {
  id: string;
  title: string;
  icon: string;
  order: number;
  count: number;
}

export interface Concept {
  id: string;
  topic: string;
  title: string;
  description: string;
  tags: string[];
  demo: string | null;
  image: string | null;
  order: number;
  headings: string[];
  path: string;
}

interface ContentState {
  topics: Topic[];
  concepts: Concept[];
  loading: boolean;
  error: string | null;
}

const ContentContext = createContext<ContentState>({
  topics: [],
  concepts: [],
  loading: true,
  error: null,
});

export const ContentProvider = ({ children }: { children: React.ReactNode }) => {
  const [state, setState] = useState<ContentState>({
    topics: [],
    concepts: [],
    loading: true,
    error: null,
  });

  useEffect(() => {
    fetch(`${process.env.PUBLIC_URL || ''}/content-index.json`, {
      headers: { Accept: 'application/json' },
    })
      .then((resp) => {
        if (!resp.ok) throw new Error(`content-index.json: HTTP ${resp.status}`);
        return resp.json();
      })
      .then((data) =>
        setState({ topics: data.topics, concepts: data.concepts, loading: false, error: null })
      )
      .catch((err) =>
        setState({ topics: [], concepts: [], loading: false, error: String(err) })
      );
  }, []);

  return <ContentContext.Provider value={state}>{children}</ContentContext.Provider>;
};

export const useContent = () => useContext(ContentContext);
